import React from "react";
import { json } from "react-router-dom";
import Content from "./components/content";
import Site from "./components/site";
import Contact from "./components/contact";
import PrivacyPolicy from "./components/privacy-policy";
import Cookies from "./components/cookie-policy";

export const routes = [
  {
    path: "/",
    loader() {
      return json({});
    },
    element: <Content />,
  },
  {
    path: "/contact",
    loader() {
      return json({});
    },
    element: <Site content={<Contact />} />,
  },
  {
    path: "/privacy-policy",
    loader() {
      return json({});
    },
    element: <Site content={<PrivacyPolicy />} />,
  },
  {
    path: "/cookies",
    loader() {
      return json({});
    },
    element: <Site content={<Cookies />} />,
  },
  {
    // 404
    path: "*",
    loader() {
      return json({});
    },
    element: <Site content={<h1>404</h1>} />,
  },
];
